import { useStaticQuery } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";
import React, { useEffect } from "react";
import { getGaProductName } from "../../qnb/gtmConverter";
import { pushDataLayer } from "../../shared/context/gtm-manager";
var Livechat = function Livechat(props) {
    var _useI18next = useI18next(), language = _useI18next.language;
    var paths = ["qnb", "about-us", "news-centre", "sustainability", "important-notice", "promotions", "product-recommendations", "online-claim", "faq", "contact-us", "currency-rate", "blue-insurance-mobile-app"];
    var _ref = useStaticQuery("3959838233"), version = _ref.version;
    useEffect(function () {
        var _version$livechatId;
        var first = window.document.head.firstChild;
        var handler = function handler() {
            var path = window.location.pathname;
            var pathArr = path.split("/")[2];
            var chatIconElement = document.querySelector('[data-gainsight-id="livechat-widget"]');
            if (chatIconElement) {
                var computedStyle = window.getComputedStyle(chatIconElement);
                var visibility = computedStyle.getPropertyValue("visibility");
                if (visibility === "visible") {
                    pushDataLayer({ event: "trackEventNoEcommerce",
                        "eventDetails.category": "chat",
                        "eventDetails.action": "clicked",
                        "eventDetails.label": props.gtmLabel,
                        location: pathArr === "category" || pathArr === "wemedi-group-medical-protector" ? "product category" : pathArr === undefined || pathArr === "" ? "home" : !paths.includes(pathArr) || getGaProductName(props.gtmProductCode) === "WeSave E1" || getGaProductName(props.gtmProductCode) === "WeSave S3" ? "product" : pathArr,
                        typeOfPolicy: getGaProductName(props.gtmProductCode) //required, refer to "GA Product Name", set the value to undefined if not applicable
                    });
                }
            }
        };
        var infobipFunctionTag = document.createElement("script");
        var infobipFunction = "(function(I,n,f,o,b,i,p){I[b]=I[b]||function(){(I[b].q=I[b].q||[]).push(arguments)};I[b].t=1*new Date();i=n.createElement(f);i.async=1;i.src=o;p=n.getElementsByTagName(f)[0];p.parentNode.insertBefore(i,p)})(window,document,'script','https://livechat.infobip.com/widget.js','liveChat');";
        var infobipInit = "liveChat('init', '" + ((_version$livechatId = version === null || version === void 0 ? void 0 : version.livechatId) !== null && _version$livechatId !== void 0 ? _version$livechatId : "") + "');";
        var infobipLang = "liveChat('set_language', '" + (language === "en" ? "en-US" : "zh-TW") + "');";
        infobipFunctionTag.append(infobipFunction);
        infobipFunctionTag.append(infobipInit);
        infobipFunctionTag.append(infobipLang);
        window.document.head.appendChild(infobipFunctionTag);
        window.document.head.insertBefore(infobipFunctionTag, first);
        window.addEventListener("click", handler);
        var cleanUp = function cleanUp() { window.removeEventListener("click", handler); };
        return function () { cleanUp(); infobipFunctionTag.remove(); };
    }, [props.gtmLabel, props.gtmProductCode]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null);
};
export default Livechat;
